<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col cols="12" md="6">
        <date-navigator v-if="showDateFilter" v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
          <div class="text-center">
            <v-btn v-if="showDateFilter" small color="primary" dark class="mx-1" @click="loadData">
              دریافت اطلاعات
            </v-btn>
          </div>
        </date-navigator>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn color="secondary" outlined small fab class="mx-1" @click="loadData()" v-if="!showDateFilter">
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
        <export-excel :items="items" :headers="headers" :fileName="'لیست تسویه صورتحساب های الکترونیکی نماینده'" :ignoreCheckPermission="true">
        </export-excel>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
          <template v-slot:item.saveDate_Persian="{ item }">&lrm; {{ item.saveDate_Persian.date }}
            {{ item.saveDate_Persian.time }}
          </template>
          <template v-slot:item.amount="{ item }">
            {{ item.amount.toString().toPriceFormat() }}
            <small class="mr-1">تومان</small>
          </template>
          <template v-slot:item.agent="{ item }">
            {{ item.agent.businessName }}
          </template>
          <template v-slot:item.agentFactors="{ item }">
            <div class="d-flex w-100 flex-wrap">
              <span class="info--text pointer" style="background-color: #cef5f1;border-radius: 10px;padding: 3px;margin: 3px;" v-for="ag in item.agentFactors" :key="ag.id" @click="$emit('showFactor', ag.id)">
                صورتحساب: {{ ag.code }} مبلغ: {{ ag.amount.toString().toPriceFormat() }}
              </span>
            </div>
          </template>
          <template v-slot:item.operations="{ item }">
            <td class="text-center">
              <v-btn class="mx-1" fab dark x-small color="secondary" @click="editTransaction(item)" v-if="area === 'admin'">
                <v-icon dark>
                  mdi-square-edit-outline
                </v-icon>
              </v-btn>
              <v-btn class="mx-1" fab dark x-small color="pink" @click="removeTransaction(item)" v-if="area === 'admin'">
                <v-icon dark small>
                  mdi-trash-can-outline
                </v-icon>
              </v-btn>
              <v-btn class="mx-1" x-small color="secondary" @click="editTransaction(item)" v-if="area === 'agent'">
                مشاهده جزئیات
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <confirm-dlg ref="confirm" />
    <v-dialog v-model="dialogTransaction" scrollable max-width="925px">
      <v-card>
        <v-card-title>
          <div><span class="headline"></span></div>
          <v-spacer />
          <v-btn @click="dialogTransaction = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <AgentFactorcCheckoutTransactionModify v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" :area="area" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from "@/util/app-api"
  import toast from "@/util/toast"

  export default {
    name: "AgentFactorcCheckoutTransactionModify",
    props: {
      agentId: { type: Number },
      agentFactorId: { type: String },
      showDateFilter: { type: Boolean },
      area: { type: String }
    },
    components: {
      ConfirmDlg: () => import("@/components/Confirm"),
      "date-navigator": () => import("@/components/DateNavigator"),
      AgentFactorcCheckoutTransactionModify: () =>
        import("@/components/forms/AgentFactorcCheckoutTransactionModify")
    },
    data() {
      return {
        selectedTransaction: null,
        dialogTransaction: false,
        errorMessages: "",
        dateRange: { start: "", end: "" },
        search: "",
        loading: false,
        headers: [
          {
            text: "نماینده",
            align: "start",
            sortable: true,
            value: "agent"
          },
          {
            text: "تاریخ واریز",
            align: "center",
            sortable: true,
            value: "saveDate_Persian"
          },
          {
            text: "مبلغ تراکنش",
            align: "start",
            sortable: true,
            value: "amount"
          },
          {
            text: "صورتحساب ها",
            align: "start",
            sortable: true,
            value: "agentFactors"
          },
          {
            text: "توضیحات",
            align: "start",
            sortable: true,
            value: "description"
          },
          {
            text: "عملیات ها",
            align: "center",
            sortable: false,
            value: "operations",
            width: 130
          }
        ],
        items: []
      }
    },
    mounted() {
      if (!this.showDateFilter) this.loadData()
    },
    methods: {
      loadData() {
        this.loading = true
        api
          .get(
            `${this.area}Transaction/GetAgentFactorTransactionsList?${this.agentFactorId ? "agentFactorId=" + this.agentFactorId : ""
            }${this.agentId ? "&agentId=" + this.agentId : ""}${this.dateRange?.start ? "&start=" + this.dateRange?.start : ""
            }${this.dateRange?.end ? "&end=" + this.dateRange?.end : ""}`,
            null
          )
          .then(response => {
            this.items = response
          })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(() => {
            this.loading = false
          })
      },
      async removeTransaction(item) {
        if (!item) {
          return
        }

        if (
          await this.$refs.confirm.open(
            "توجه",
            "آیا از حذف این آیتم مطمئن هستید؟"
          )
        ) {
          api
            .post("admin/transaction/delete/" + item.id)
            .then(response => {
              toast.success("اطلاعات با موفقیت حذف شد.")
              this.loadData()
              this.$emit("update")
            })
            .catch(err => {
              toast.error(err.message)
            })
        }
      },
      editTransaction(item) {
        this.selectedTransaction = item
        this.dialogTransaction = true
      },
      callbck_transaction(result) {
        this.dialogTransaction = false
        if (result) {
          this.loadData()
          this.$emit("update")
        }
      }
    }
  }
</script>
<style></style>
